import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, InputField, InputSlot, InputIcon } from '@/components/gluestack/input';
import { CloseIcon } from '@/components/gluestack/icon';
import { Search02Icon } from '@hugeicons-pro/core-solid-rounded';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';

interface MessageSearchProps {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  autoFocus?: boolean;
}

export const MessageSearch = ({
  searchQuery,
  onSearchQueryChange: setSearchQuery,
  autoFocus = false,
}: MessageSearchProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(searchQuery);

  // Keep inputValue in sync with searchQuery from props
  useEffect(() => {
    setInputValue(searchQuery);
  }, [searchQuery]);

  const handleSearch = () => {
    setSearchQuery(inputValue);
  };

  const clearSearch = () => {
    setInputValue('');
    setSearchQuery('');
  };

  return (
    <Input className="m-4" variant="rounded">
      <InputSlot className="pl-3">
        <HugeIconsWrapper icon={Search02Icon} size={16} className="color-typography-700" />
      </InputSlot>
      <InputField
        placeholder={t('messages.search_placeholder')}
        value={inputValue}
        onChangeText={(text) => setInputValue(text)}
        returnKeyType="search"
        onSubmitEditing={handleSearch}
        autoFocus={autoFocus}
        autoCorrect={false}
        autoCapitalize="none"
        autoComplete="off"
        textContentType="none"
        importantForAutofill="no"
      />
      {inputValue.length > 0 && (
        <InputSlot className="pr-2" onPress={clearSearch}>
          <InputIcon as={CloseIcon} />
        </InputSlot>
      )}
    </Input>
  );
}; 